// extracted by mini-css-extract-plugin
module.exports = {"container":"play-button_container__2_ylb","rotate":"play-button_rotate__1mdBa"};